import { Button, ButtonGroup } from 'react-bootstrap';
import { FaBold, FaItalic, FaHeading, FaLink, FaImage, FaCode, FaQuoteLeft, FaListOl, FaListUl } from 'react-icons/fa';

export default function MarkdownToolbar({ textareaRef }) {
  const insert = (before, after = '') => {
    const ta = textareaRef.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    const selected = ta.value.substring(start, end);
    const replacement = `${before}${selected || 'text'}${after}`;
    ta.focus();
    document.execCommand('insertText', false, replacement);
    const cursorPos = start + before.length + (selected || 'text').length;
    ta.setSelectionRange(cursorPos, cursorPos);
  };

  const insertLine = (prefix) => {
    const ta = textareaRef.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const before = ta.value.substring(0, start);
    const needsNewline = before.length > 0 && !before.endsWith('\n');
    const text = `${needsNewline ? '\n' : ''}${prefix}`;
    ta.focus();
    document.execCommand('insertText', false, text);
  };

  return (
    <ButtonGroup size='sm' className='mb-2 flex-wrap'>
      <Button variant='outline-secondary' title='Bold' onClick={() => insert('**', '**')}>
        <FaBold />
      </Button>
      <Button variant='outline-secondary' title='Italic' onClick={() => insert('*', '*')}>
        <FaItalic />
      </Button>
      <Button variant='outline-secondary' title='Heading' onClick={() => insertLine('## ')}>
        <FaHeading />
      </Button>
      <Button variant='outline-secondary' title='Link' onClick={() => insert('[', '](url)')}>
        <FaLink />
      </Button>
      <Button variant='outline-secondary' title='Image' onClick={() => insert('![alt](', ')')}>
        <FaImage />
      </Button>
      <Button variant='outline-secondary' title='Code' onClick={() => insert('`', '`')}>
        <FaCode />
      </Button>
      <Button variant='outline-secondary' title='Quote' onClick={() => insertLine('> ')}>
        <FaQuoteLeft />
      </Button>
      <Button variant='outline-secondary' title='Ordered list' onClick={() => insertLine('1. ')}>
        <FaListOl />
      </Button>
      <Button variant='outline-secondary' title='Unordered list' onClick={() => insertLine('- ')}>
        <FaListUl />
      </Button>
    </ButtonGroup>
  );
}
